import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";


interface IMySolutionCards {
    solutionStatistics: any
}

const MysolutionCards: FC<IMySolutionCards> = (props) => {
    const { solutionStatistics } = props;

    const { t } = useTranslation();

    let myEmail = localStorage["userEmailInCaseHeLogsOut"];
    const myUseOfSolutionTypes = useMemo(() => solutionStatistics?.find((statistic: any) => statistic.player.email === myEmail), [myEmail, solutionStatistics]);
    
    if(!solutionStatistics || !myUseOfSolutionTypes){
        return(<div></div>)
    }

    const { Mental, Physical, Relations, Emotional} = myUseOfSolutionTypes.player.solutionStatisticForCircleAroundGame;

    const totalUses = Mental + Physical + Relations + Emotional;
    
    const pieStyle: any = (solutionCardType : any) => {
        const totalUses = Mental + Physical + Relations + Emotional;
        
        if(totalUses === 0) {
            return { width: "100%", height: "100%", bottom: "-50%", left: "50%"  }
        }

        return  {
            width: `${100 + ((solutionCardType / totalUses) * 100) + "%"}`,
            height: `${100 + ((solutionCardType / totalUses) * 100) + "%"}`,
            bottom:  `${(50 * (solutionCardType / totalUses )) - 50 + `%`}`,
            left:  `${50 - (50 * (solutionCardType / totalUses )) + `%`}` }
    }
    

    const showPercentage: any = (solutionCardType: any) => {

        if(totalUses === 0) 
            return 0;

        if(totalUses !== 0)
            return Math.round(solutionCardType / totalUses * 100);
    }


    return (
        <div className="my_solution_container">
            <div className="center">
            <div>
                <p className="solution_type_text_mental"> {t("mentalText")} </p>
                <p className="solution_type_text_social"> {t("socialText")} </p>
                </div>
                <div className="wrapper">
                    
                    <div className="box boxone"> 
                    <div className="innercircle innercircleone" style={pieStyle(Mental)}> </div>
                        <div className="innercircleholder inner_circle_holder_one"> </div>
                    </div>
                   
                    <div className="box boxtwo"> 
                    <div className="innercircle innercircletwo" style={pieStyle(Physical)}> </div>
                        <div className="innercircleholder inner_circle_holder_two"> </div>
                    </div>
            
                     <div className="box boxthree"> 
                     <div className="innercircle innercirclethree" style={pieStyle(Relations)}> </div>
                        <div className="innercircleholder inner_circle_holder_three"> </div>
                    </div>
            
                    <div className="box boxfour"> 
                    <div className="innercircle innercirclefour" style={pieStyle(Emotional)}> </div>
                        <div className="innercircleholder inner_circle_holder_four"> </div>
                        
                    </div>  
            
                    <div className="imgwrapper center">
                        <img className="image" src={`${process.env.REACT_APP_BACKEND_URL}images/${myEmail}.png`} alt="statistics" />
                    </div>
                </div>
                <div className="percentagewrapper">
                    
                    <div className="percentage percentage_one"> 
                    {showPercentage(Mental)}%
                    </div>
                   
                    <div className="percentage percentage_two"> 
                    {showPercentage(Physical)}%
                    </div>

                    <div className="percentage percentage_three"> 
                    {showPercentage(Relations)}%
                    </div> 
        
                    <div className="percentage percentage_four"> 
                    {showPercentage(Emotional)}%
                    </div>
                </div>
                <div>
                <p className="solution_type_text_physical"> {t("physicalText")} </p>
                <p className="solution_type_text_emotional"> {t("emotionalText")} </p>
                </div>
            </div>
        </div>
    )
};

export default MysolutionCards;